import useLang from "../hooks/useLang";
import Label from "./Label";
import P from "./Paragraph";
import List from "./List";
import Table from "./Table";
import GridLayout from "./GridLayout";
import SpectrumPreview from "../features/spectrum/SpectrumPreview";
import SpectraArray from "../features/spectrum/SpectraArray";
import styles from "./sectionItem.module.css";
import Button from "./Button";

const TextItem = ({ value, ...rest }) => {
  return <P {...rest}>{value}</P>;
};

const ItemWithLabel = ({ id, value, displayValue, label, link, ...rest }) => {
  const lang = useLang();
  if (link != null) {
    return (
      <div className={styles.row} {...rest}>
        {label !== null && label !== false && (
          <Label>{label || lang(`captions.${id}`)}</Label>
        )}
        <Button inline unpadded navigation to={link} target="_blank">
          {displayValue || value}
        </Button>
      </div>
    );
  }
  return (
    <div className={styles.row} {...rest}>
      {label !== null && label !== false && (
        <Label>{label || lang(`captions.${id}`)}</Label>
      )}
      <TextItem value={displayValue || value} />
    </div>
  );
};

const SectionItem = ({
  type,
  formOnly,
  required,
  idAsValue,
  inputWidth,
  isValid,
  ...rest
}) => {
  if (formOnly === true) return null;
  if ((type == null || type === "textarea") && rest?.id == null)
    return <TextItem {...rest} />;
  if ((type == null || type === "textarea") && rest?.id != null)
    return <ItemWithLabel {...rest} />;
  if (type === "list" || type === "matrix") return <List {...rest} />;
  if (type === "table") return <Table {...rest} />;
  if (type === "grid") return <GridLayout {...rest} />;
  if (type === "spectrum")
    return <SpectrumPreview {...rest} id={null} viewOnly />;
  if (type === "spectraArray") return <SpectraArray {...rest} />;
  return <ItemWithLabel {...rest} />;
};

export default SectionItem;
